import {inject, Injectable, PLATFORM_ID, signal} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '../../../environments/environment';
import Clarity from '@microsoft/clarity';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftClarityService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly initialized = signal(false);
  private readonly CLARITY_PROJECT_ID = environment.analytics.microsoft.clarityProjectId;
  private readonly enabled = environment.analytics.microsoft.enabled;

  public init(): void {
    if (!this.isBrowser || this.initialized()) return;

    if (!this.enabled) {
      console.warn('Clarity analytics is disabled');
      return;
    }

    Clarity.init(this.CLARITY_PROJECT_ID);
    this.initialized.set(true);
  }

  public identify(customId: string, sessionId?: string, pageId?: string, friendlyName?: string): void {
    if (!this.isBrowser || !this.initialized()) return;
    Clarity.identify(customId, sessionId, pageId, friendlyName);
  }

  public setTag(key: string, value: string | string[]): void {
    if (!this.isBrowser || !this.initialized()) return;
    Clarity.setTag(key, value);
  }

  public trackEvent(name: string): void {
    if (!this.isBrowser || !this.initialized()) return;
    Clarity.event(name);
  }

  public upgradeSession(reason: string): void {
    if (!this.isBrowser || !this.initialized()) return;
    Clarity.upgrade(reason);
  }

  public consent(): void {
    if (!this.isBrowser || !this.initialized()) return;
    Clarity.consentV2();
  }
}
